"use client";
import React from "react";
import { useRouter } from "next/navigation";
import { ArrowRight } from "@phosphor-icons/react";

import type { VariantProps } from "class-variance-authority";
import type { buttonVariants } from ".";

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  link?: string;
}

const BackButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ link, className, ...props }, ref) => {
    const router = useRouter();

    const handleBack = () => {
      link ? router.push(link) : router.back();
    };

    return (
      <button
        className={` md:hidden ${className}`}
        onClick={handleBack}
        ref={ref}
        {...props}
      >
        <ArrowRight className="w-6 h-6" />
      </button>
    );
  },
);

BackButton.displayName = "BackButton";

export { BackButton };
